import GET_RETAIL_ZONES from './getRetailZones.graphql'
export default GET_RETAIL_ZONES
